/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

// Plugins
import { registerPlugins } from '@/plugins'

import { vMaska } from "maska"

const app = createApp(App)

import mitt from 'mitt';
const emitter = mitt();
app.config.globalProperties.emitter = emitter;

import firebase from 'firebase/compat/app'
import 'firebase/compat/analytics'

if(import.meta.env.VITE_FIREBASE_APIKEY != ''){
    firebase.initializeApp({
        apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
        projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
        appId: import.meta.env.VITE_FIREBASE_APPID,
    })
    app.config.globalProperties.$analytics = firebase.analytics();
}

app.directive("maska", vMaska);

registerPlugins(app)

app.mount('#app')

app.provide('root', 'Vue3');
